import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Nav, Modal } from "react-bootstrap";
import { FaDownload, FaFileCirclePlus, FaRegSquarePlus, FaWandMagicSparkles } from "react-icons/fa6";
import * as yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import CustomisedModal from "../../components/Modal/CustomisedModal";
import sampleFile from "../../assets/files/sample-sheet.xlsx";
import sampleImageFile from "../../assets/files/images.zip";
import { Paper, Switch, Tooltip } from "@mui/material";
import DataTable from "react-data-table-component";
import Loader from "../../components/loader/loader";
import { checkUserPermissions } from "../../helpers/permission";
import { useNavigate } from "react-router";
import {
  deleteProduct,
  downloadProductsExcelSheet,
  getProductsListing,
  getProductsLowStockListing,
  getProductsOutStockListing,
  getProductsVariants,
  statusProductUpdate,
  uploadBulkProducts,
} from "../../api/context/products";
import Variant from "./Variant";
import { RiArrowDownSLine } from "react-icons/ri";
import { FaCloudUploadAlt } from "react-icons/fa";
import { Box } from "@material-ui/core";
import { getCategoryListingPaginate, getManufacturesListingPaginate, getStoresListing, getSubCategoryListingPaginate } from "../../api/context/manufacturer";
import { useRecoilState } from "recoil";
import { inventoryListFilter, inventoryPaginationState } from "../../atoms/inventoryListFIlter";
import AsyncSelect from 'react-select/async';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getBrandListing } from "../../api/context/brand";
import { Spinner } from "reactstrap";
import { FiDownload, FiFilter, FiPackage, FiPlus, FiRefreshCw, FiTrash2, FiUploadCloud } from "react-icons/fi";
import BulkUploadModal from "./helpers/bulkUploadModal";
import FilterModal from "./helpers/filterModal";

const queueDatatableCustomStyles = {
  header: {
    style: {
      fontWeight: '600',
      fontSize: '22px',
      color: '#000',
    },
  },
  headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '13px',
      padding: '16px 8px',
      backgroundColor: '#f9f9f9ff',
    },
  },
  cells: {
    style: {
      display: "flex",
      fontSize: '11px',
      fontWeight: '500',
      padding: '12px',
    },
  },
};

const Inventory = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.userType === "ADMIN";

  // Recoil State Management
  const [filterData, setFilterData] = useRecoilState(inventoryListFilter);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [pagination, setPagination] = useRecoilState(inventoryPaginationState);

  // Local State
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [show, setShow] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [totalExpandedRows, setTotalExpandedRows] = useState(0);
  const [totalActiveRows, setTotalActiveRows] = useState(0);
  const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [update, setUpdate] = useState(false);
  const [updateoutstock, setUpdateOutStock] = useState(false);
  const [updatelowstock, setUpdateLowStock] = useState(false);
  const [activedata, setActiveData] = useState([]);
  const [inactivedata, setInActiveData] = useState([]);
  const [category, setCategory] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [data, setData] = useState([]);
  const [variantdata, setVariantData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [defaultLoading, setDefaultLoading] = useState(false);
  const [loadingnested, setLoadingNested] = useState(false);
  const [initial, setInitial] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [store, setStore] = useState([]);
  const [modal, setModal] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [showOff, setShowOff] = useState(false);
  const [brands, setBrands] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [pagebrands, setPageBrands] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pagemanufacture, setPageManufacture] = useState(1);
  const [hasMoreManufacture, setHasMoreManufacture] = useState(true);
  const [enableBulkInventory, setEnableBulkInventory] = useState(false);
  const [downloadInventoryExcel, setDownloadInventoryExcel] = useState(false);
  const [totalInventoryToDownload, setTotalInventoryToDownload] = useState([]);
  const [updatingStatusIds, setUpdatingStatusIds] = useState(new Set());

  // Derived state from Recoil
  const { page, limit, pageactive, limitactive, pageinactive, limitinactive } = pagination;
  const { filter, search } = filterData;

  const handleCloseOff = () => setShowOff(false);
  const handleShowOff = () => setShowOff(true);

  const stockViewOptions = [
    { value: "all", label: "All" },
    { value: "active", label: "Out of Stock" },
    { value: "inactive", label: "Low Stock" },
  ];

  const toggleModal = () => {
    setModal(!modal);
  };


  const handleShowBulkModal = () => {
    setShowBulkModal(true);
  };

  const handleShow = () => {
    setShow(true);
    setEnableBulkInventory(false);
  }

  const handleCloseBulkModal = () => {
    setShowBulkModal(false);
  };

  const handleBulkUploadSuccess = () => {
    setUpdate(!update);
  };

  // Columns Definition
  const columns = [
    {
      name: "S. No.",
      selector: (row, index) => {
        if (filter === "all") {
          return page * limit - limit + (index + 1);
        } else if (filter === "active") {
          return pageactive * limitactive - limitactive + (index + 1);
        } else if (filter === "inactive") {
          return pageinactive * limitinactive - limitinactive + (index + 1);
        } else {
          return page * limit - limit + (index + 1);
        }
      },
      center: true,
      minWidth: "70px",
      grow: 1,
      cell: (row, index) => (
        <div className="text-center">
          {filter === "all"
            ? page * limit - limit + (index + 1)
            : filter === "active"
              ? pageactive * limitactive - limitactive + (index + 1)
              : pageinactive * limitinactive - limitinactive + (index + 1)
          }
        </div>
      ),
    },
    {
      id: "productname",
      name: "Product Name",
      selector: (row) => row?.productName,
      cell: (row) => (
        <div
          className="related-order-box text-truncate"
          style={{
            color: "black",
            padding: "4px 8px",
            borderRadius: "4px",
            fontWeight: "500",
            cursor: "pointer",
            minWidth: "80px",
            margin: "2px",
            width: "100%",
          }}
          onClick={(e) => {
            e.stopPropagation();
            navigate("/edit-inventory/" + row.id);
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              width: "100%",
            }}
          >
            {row?.isAiGenerated && (
              <Tooltip title="AI generated" disableInteractive placement="top">
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#008695",
                    flexShrink: 0,
                    fontSize: "14px",
                  }}
                >
                  <FaWandMagicSparkles />
                </span>
              </Tooltip>
            )}

            <Tooltip title={row?.productName} disableInteractive placement="top">
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                  display: "inline-block",
                  flex: "1 1 auto",
                  minWidth: 0,
                  textAlign: "center",
                }}
              >
                {row?.productName}
              </span>
            </Tooltip>

            {Number(row?.notifyMeCount) > 0 && (
              <Tooltip
                title={`${Number(row?.notifyMeCount)} pending notify request${Number(row?.notifyMeCount) > 1 ? "s" : ""}`}
                arrow
                placement="top"
              >
                <span
                  style={{
                    minWidth: "22px",
                    height: "22px",
                    borderRadius: "50%",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: "700",
                    padding: "0 6px",
                    lineHeight: 1,
                    cursor: "pointer",
                  }}
                >
                  {Number(row?.notifyMeCount)}
                </span>
              </Tooltip>
            )}
          </div>
        </div>
      ),
      minWidth: "100px",
      grow: 1,
      center: true,
    },
    {
      id: "colors",
      name: "Colors",
      selector: (row) => row?.color,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <div
            className="color_code"
            style={{
              width: "20px",
              height: "20px",
              border: "1px solid #e5e7eb",
              borderRadius: "50%",
              backgroundColor: row.color,
            }}
          ></div>
        </div>
      ),
      minWidth: "80px",
      grow: 1,
      center: true,
    },
    ...(user?.userType === "ADMIN" ? [{
      id: 'storeName',
      name: 'Store',
      selector: (row) => row?.manufacturer?.storeName,
      cell: (row) => {
        const platform = row?.manufacturer?.externalPlatform?.toLowerCase();
        const platformData = {
          'woocommerce': { initial: 'W', color: '#96588a' },
          'shopify': { initial: 'S', color: '#5e8e3e' },
          'magento': { initial: 'M', color: '#f46f25' },
        };
        const platformInfo = platformData[platform];

        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: '100%',
              cursor: 'pointer',
              padding: '6px 8px',
              gap: '8px',
              minWidth: 0,
              textDecoration: 'underline',
              textUnderlineOffset: '2px',
              textDecorationThickness: '1px',
              textDecorationColor: '#a94b4bff',
            }}
            onClick={() => navigate('/edit-vendors/' + row?.manufacturer?.id)}
          >
            {platformInfo && (
              <div
                style={{
                  flexShrink: 0,
                  width: '20px',
                  height: '20px',
                  borderRadius: '4px',
                  color: platformInfo.color,
                  border: `1px solid ${platformInfo.color}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              >
                {platformInfo.initial}
              </div>
            )}
            <Tooltip title={row?.manufacturer?.storeName} disableInteractive placement="top">
              <div
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: 0,
                }}
              >
                {row?.manufacturer?.storeName}
              </div>
            </Tooltip>
          </div>
        );
      },
      sortable: true,
      minWidth: '150px',
      grow: 1,
      center: true,
    }] : []),
    {
      id: "category",
      name: "Category",
      selector: (row) => row?.productSubcategory?.title,
      cell: (row) => {
        const category = row?.productSubcategory?.title?.toLowerCase();
        let bgColor = '';
        let textColor = 'white';

        if (category?.includes('men')) {
          bgColor = '#5282ceff';
        } else if (category?.includes('woman')) {
          bgColor = '#ec4899';
        } else if (category?.includes('kid')) {
          bgColor = '#22c55e';
        } else {
          bgColor = 'gray';
          textColor = 'black';
        }

        return (
          <div className="text-center">
            {row?.productSubcategory?.title ? (
              <Tooltip title={row?.productSubcategory?.title} disableInteractive placement="top">
                <span
                  style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontWeight: '500',
                    display: 'inline-block',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {row.productSubcategory.title}
                </span>
              </Tooltip>
            ) : (
              'N/A'
            )}
          </div>
        );
      },
      minWidth: "110px",
      grow: 1,
      center: true,
    },
    {
      id: "price",
      name: "Price",
      selector: (row) => row?.price,
      cell: (row) => (
        <div className="text-center text-truncate">
          {row?.price != null && row?.price !== '' ? row.price : '-'}
        </div>
      ),
      minWidth: "90px",
      grow: 1,
      center: true,
    },
    {
      id: "discount",
      name: "Discounted",
      selector: (row) => row?.discountedPrice,
      cell: (row) => (
        <div className="text-center text-truncate">
          {row?.discountedPrice != null && row?.discountedPrice !== '' ? row.discountedPrice : '-'}
        </div>
      ),
      minWidth: "110px",
      grow: 1,
      center: true,
    },
    {
      id: "stock",
      name: "Stock",
      selector: (row) => row?.stock,
      cell: (row) => (
        <div
          className="text-center text-truncate"
          style={{
            fontWeight: row?.stock <= 0 ? 'bold' : 'semibold',
            color: row?.stock <= 0 ? '#dc3545' : 'inherit'
          }}
        >
          {row?.stock <= 0 ? '0' : row?.stock}
        </div>
      ),
      minWidth: "80px",
      grow: 1,
      center: true,
    },
    {
      id: "action",
      name: "Actions",
      cell: (row, index) => (
        <div className="d-flex justify-content-center">
          {checkUserPermissions("manage_products") ? (
            <div className="d-flex align-items-center">
              <div className="d-flex flex-row align-items-center gap-3" role="button">
                <div className="d-flex justify-content-center">
                  {row?.isAiGenerated === true && row?.isPublished === false ? (
                    <Tooltip title="Publish this draft first to enable" disableInteractive placement="top">
                      <span>
                        <Switch
                          size="20px"
                          id={`custom-switch-${index}`}
                          checked={row?.isActive}
                          disabled
                          className="custom-switch"
                        />
                      </span>
                    </Tooltip>
                  ) : (
                    <Switch
                      size="20px"
                      id={`custom-switch-${index}`}
                      checked={row?.isActive}
                      disabled={updatingStatusIds.has(row?.id)}
                      onChange={() => statusActive(row?.id)}
                      className="custom-switch"
                    />
                  )}
                </div>

                <Tooltip title="Delete" disableInteractive placement="top">
                  <div className="delete_icon_bg" onClick={() => handleConfirm(row?.id)}>
                    <FiTrash2 className="delete_icon text-black fs-5" />
                  </div>
                </Tooltip>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      ),
      center: true,
      minWidth: "100px",
      grow: 1,
    },
  ];

  const conditionalRowStyles = [
    {
      when: row => row.stock <= 0,
      style: {
        backgroundColor: 'rgba(238, 145, 155, 0.1)',
        '&:hover': {
          backgroundColor: 'rgba(238, 145, 155, 0.1)'
        }
      },
    },
  ];

  // Search Formik with Recoil Integration
  const searchFormik = useFormik({
    initialValues: {
      category: filterData.category || [],
      subCategory: filterData.subCategory || [],
      subSubCategory: filterData.subSubCategory || [],
      vendors: isAdmin ? (filterData.vendors || []) : [],
      brands: isAdmin ? (filterData.brands || []) : [],
      search: filterData.search || "",
      filter: filterData.filter || "all",
      minPrice: filterData.minPrice || 0,
      maxPrice: filterData.maxPrice || 99999
    },
    onSubmit: (values) => {

      setFilterData(prev => ({
        ...prev,
        category: values.category,
        subCategory: values.subCategory,
        subSubCategory: values.subSubCategory,
        vendors: values.vendors,
        brands: values.brands,
        search: values.search,
        filter: values.filter,
        minPrice: values.minPrice,
        maxPrice: values.maxPrice
      }));
    },
  });

  // Update Recoil state when form values change
  useEffect(() => {
    setFilterData(prev => ({
      ...prev,
      ...searchFormik.values
    }));
  }, [searchFormik.values, setFilterData]);

  // API Calls with Recoil State
  const fetchProductsData = async () => {
    const params = {
      page: pagination.page,
      limit: pagination.limit,
      search: filterData.search || '',
      category: null,
      subCategory: filterData.category || [],
      subSubCategory: filterData.subCategory || [],
      vendors: filterData.vendors || [],
      brands: filterData.brands || [],
      stock: filterData.stock || [],
      minPrice: filterData.minPrice || 0,
      maxPrice: filterData.maxPrice || 99999
    };

    getProductsListing(params)((response) => {
      if (response?.statusCode === 200) {
        setData(response?.data?.products);
        setTotalRows(response?.data?.totalItems);
        setDefaultLoading(false);
      } else {
        setData([]);
        setDefaultLoading(false);
      }
    });
  };

  const handleConfirm = (deletingId) => {
    setModal(!modal);
    setDeletingId(deletingId);
  };

  const deleteProducts = (id) => {
    setLoading(true)
    deleteProduct(id)((response) => {
      if (response?.data?.statusCode == 200) {
        setUpdate(!update);
        setModal(!modal);
        setLoading(false);
        toast.success("Product deleted successfully")
      } else {
        setLoading(false);
        toast.error(response?.data?.message);
      }
    });
  };

  const statusActive = (id) => {
    setUpdatingStatusIds((prev) => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });
    statusProductUpdate(id)((response) => {
      setUpdatingStatusIds((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      if (response?.data?.statusCode == 200) {
        setData((prev) =>
          prev.map((product) =>
            product.id === id
              ? { ...product, isActive: !product.isActive }
              : product
          )
        );
        setVariantData((prev) =>
          prev.map((v) =>
            v.id === id ? { ...v, isActive: !v.isActive } : v
          )
        );
      } else {
        toast.error(response?.data?.message || "Failed to update status");
      }
    });
  };


  // Pagination Handlers with Recoil
  const handlePerRowsChange = (newPerPage, page) => {
    setPagination(prev => ({
      ...prev,
      limit: newPerPage,
      page: 1
    }));
    setUpdate(!update);
  };

  const handlePerRowsActiveChange = (newPerPage, page) => {
    setPagination(prev => ({
      ...prev,
      limitactive: newPerPage,
      pageactive: 1
    }));
    setUpdateOutStock(!updateoutstock);
  };

  const handlePerRowsInactiveChange = (newPerPage, page) => {
    setPagination(prev => ({
      ...prev,
      limitinactive: newPerPage,
      pageinactive: 1
    }));
    setUpdateLowStock(!updatelowstock);
  };

  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      page
    }));
    setUpdate(!update);
  };

  const handlePageActiveChange = (page) => {
    setPagination(prev => ({
      ...prev,
      pageactive: page
    }));
    setUpdateOutStock(!updateoutstock);
  };

  const handlePageInactiveChange = (page) => {
    setPagination(prev => ({
      ...prev,
      pageinactive: page
    }));
    setUpdateLowStock(!updatelowstock);
  };

  // Search Handler with Recoil
  const handleSearchChange = (value) => {
    setFilterData(prev => ({
      ...prev,
      search: value
    }));
  };

  // Filter Handlers with Recoil
  const applyFilters = (partial) => {
    const processedPartial = {};

    Object.keys(partial).forEach(key => {
      if (Array.isArray(partial[key])) {
        processedPartial[key] = partial[key].map(item => {
          if (typeof item === 'object' && item !== null) {
            return item.id || item.value;
          }
          return item;
        }).filter(id => id !== undefined);
      } else {
        processedPartial[key] = partial[key];
      }
    });

    const next = { ...searchFormik.values, ...processedPartial };
    searchFormik.setValues(next);
    setFilterData(prev => ({ ...prev, ...processedPartial }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const onBrandChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      brands: selectedValues
    });
  };

  const onManufactureChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      vendors: selectedValues
    });
  };

  const onCategoryChange = (selectedOption) => {
    applyFilters({
      category: selectedOption ? [selectedOption.value] : []
    });
  };

  const onSubCategoryChange = (selectedOptions) => {
    applyFilters({
      subCategory: selectedOptions && selectedOptions.length > 0
        ? selectedOptions.map(option => option.value)
        : []
    });
  };
  const handleStockViewChange = (opt) => {
    const nextFilter = opt?.value ?? "all";
    setFilterData(prev => ({
      ...prev,
      filter: nextFilter
    }));

    // Reset appropriate pagination
    setPagination(prev => ({
      ...prev,
      ...(nextFilter === "all" && { page: 1 }),
      ...(nextFilter === "active" && { pageactive: 1 }),
      ...(nextFilter === "inactive" && { pageinactive: 1 })
    }));

    // Trigger appropriate update
    if (nextFilter === "all") {
      setUpdate(u => !u);
    } else if (nextFilter === "active") {
      setUpdateOutStock(u => !u);
    } else {
      setUpdateLowStock(u => !u);
    }
  };

  const handleReset = () => {
    const resetValues = {
      category: [],
      subCategory: [],
      subSubCategory: [],
      vendors: [],
      brands: [],
      stock: [],
      search: "",
      filter: "all",
      minPrice: 0,
      maxPrice: 99999
    };

    searchFormik.resetForm({ values: resetValues });
    setFilterData(resetValues);
    setPagination({
      page: 1,
      limit: 10,
      pageactive: 1,
      limitactive: 10,
      pageinactive: 1,
      limitinactive: 10
    });
    setUpdate(!update);
  };

  // Async Select Loaders
  let typingTimer;

  const loadOptionsCategory = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (true) {
          getCategoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setCategory(response?.results)
            } else {
              resolve([]);
            }
          })
        }
        else {
          // resolve([]);
          // setCategory([])
          // setSubCategory([])
        }
      }, 300);
    });
  };

  const loadOptionsSubCategory = inputValue => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        const categoryId = searchFormik?.values?.selectedCategory?.value;
        if (categoryId) {
          getSubCategoryListingPaginate({ page: 1, pageSize: 10, search: inputValue, categoryIds: [categoryId] })(response => {
            if (response?.statusCode == 200) {
              resolve(response?.results);
              setSubCategory(response?.results)
            } else {
              resolve([]);
            }
          })
        }
        else {
          resolve([]);
          setSubCategory([])
        }
      }, 300);
    });
  };

  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        getBrandListing({ pagebrands: currentPage, pageSize: limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            if (currentPage === 1) {
              setBrands(results);
            } else {
              setBrands((prevBrands) => [...prevBrands, ...results]);
            }

            setHasMore(results.length > 0);
            resolve(results);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };

  const loadOptionsBrands = (inputValue) => {
    return fetchBrands(inputValue, 1);
  };

  const handleMenuScrollToBottom = () => {
    if (hasMore) {
      const nextPage = pagebrands + 1;
      fetchBrands(searchFormik.values.selected_brands?.label || '', nextPage).then(() => {
        setPageBrands(nextPage);
      });
    }
  };

  const fetchManufacturers = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        getManufacturesListingPaginate({ page: currentPage, limit, search: inputValue })(response => {
          if (response?.statusCode === 200) {
            const results = response?.results?.map(item => ({
              value: item.id,
              label: item.storeName,
            }));

            if (currentPage === 1) {
              setManufacturers(results);
            } else {
              setManufacturers((prevManufacturers) => [...prevManufacturers, ...results]);
            }

            setHasMoreManufacture(results.length > 0);
            resolve(results);
          } else {
            setHasMoreManufacture(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };

  const loadOptionsManufacture = (inputValue) => {
    return fetchManufacturers(inputValue, 1);
  };

  const handleMenuScrollToBottomManufacture = () => {
    if (hasMoreManufacture) {
      const nextPage = pagemanufacture + 1;
      fetchManufacturers('', nextPage).then(() => {
        setPageManufacture(nextPage);
      });
    }
  };

  const loadStockOptions = (input) =>
    Promise.resolve(
      stockViewOptions.filter(o =>
        o.label.toLowerCase().includes((input || "").toLowerCase())
      )
    );

  const handleRowExpand = (row) => {
    setLoadingNested(true);
    const isRowExpanded = expandedRows.includes(row);
    setExpandedRows(
      [] && isRowExpanded ? expandedRows.filter((r) => r !== row) : [row]
    );
    getProductsVariants({
      productId: row.id,
      page: 1,
      pageSize: 10,
    })((response) => {
      if (response?.statusCode === 200) {
        setVariantData(response?.data?.products);
        setTotalExpandedRows(response?.data?.totalItems);
        setLoadingNested(false);
      } else {
        setVariantData([]);
        setLoadingNested(false);
      }
    });
  };

  const customNoOptionsMessage = ({ inputValue }) => {
    return <div>No options</div>;
  };

  const ExpandedComponent = useCallback(() => {
    return (
      <pre>
        <Variant
          variantdata={variantdata}
          loadingnested={loadingnested}
          statusActive={statusActive}
          handleConfirm={handleConfirm}
          handleRowExpand={handleRowExpand}
          checkUserPermissions={checkUserPermissions}
          totalExpandedRows={totalExpandedRows}
          limitvariant={10}
          pagevariant={1}
          handlePerRowsVariantChange={() => { }}
          handlePageVariantChange={() => { }}
        />
      </pre>
    );
  }, [variantdata, loadingnested]);

  // Effects
  useEffect(() => {
    if (searchFormik?.values?.subCategory) {
      getSubCategoryListingPaginate({ page: 1, limit: 10, search: '', categoryIds: searchFormik?.values?.subCategory })(response => {
        if (response?.statusCode == 200) {
          setSubCategory(response?.results)
        } else {
          setSubCategory([])
        }
      })
    }
  }, [searchFormik?.values?.subCategory]);

  useEffect(() => {
    getCategoryListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setCategory(response?.results)
      } else {
        setCategory([])
      }
    })

    getManufacturesListingPaginate({ page: 1, limit: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setManufacturers(response?.results)
      }
    })

    getBrandListing({ page: 1, pageSize: 10, search: '' })(response => {
      if (response?.statusCode == 200) {
        setBrands(response?.data?.map((item, index) => {
          return {
            value: item.id,
            label: item.name
          }
        }))
      }
    })
  }, []);

  useEffect(() => {
    setDefaultLoading(true);
    fetchProductsData();
  }, [update, filterData]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) {
        if (filter === "all") {
          setUpdate(!update);
        } else if (filter === "active") {
          setUpdateOutStock(!updateoutstock);
        } else if (filter === "inactive") {
          setUpdateLowStock(!updatelowstock);
        }
      } else {
        setInitial(!initial);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [filterData.search]);

  const getAppliedFiltersCount = () => {
    const formikValues = searchFormik?.values || {};
    let count = 0;

    const countIds = (array) => {
      if (!Array.isArray(array)) return 0;
      return array.filter(item => item !== undefined && item !== null).length;
    };

    if (isAdmin) {
      count += countIds(formikValues.brands);
      count += countIds(formikValues.vendors);
    }
    count += countIds(formikValues.category);
    count += countIds(formikValues.subCategory);
    count += countIds(formikValues.subSubCategory);
    count += countIds(formikValues.stock);

    // Count price range as 1 if min or max is different from defaults
    if ((formikValues.minPrice !== undefined && formikValues.minPrice !== 0) ||
      (formikValues.maxPrice !== undefined && formikValues.maxPrice !== 99999)) {
      count += 1;
    }

    return count;
  };

  const appliedFiltersCount = getAppliedFiltersCount();

  const exportInventoryToExcel = async () => {
    setDownloadInventoryExcel(true);

    try {
      // Build params EXACTLY matching fetchProductsData structure
      const params = {
        search: filterData.search || '',
        category: null, // Exactly as in fetchProductsData
        subCategory: filterData.category || [], // Exactly as in fetchProductsData
        subSubCategory: filterData.subCategory || [], // Exactly as in fetchProductsData
        vendors: isAdmin ? (filterData.vendors || []) : [],
        brands: isAdmin ? (filterData.brands || []) : [],
        minPrice: 0,
        maxPrice: 99999,
        // Add filter view param if needed
        filter: filter, // "all", "active", or "inactive"
        // For export, we typically want all data (not paginated)
        page: 1,
        limit: 1000000, // Large number to get all data
        // Include pagination state if needed for consistency
        ...pagination
      };

      console.log('Export params (matched with fetchProductsData):', params);

      // Call backend export API - should accept same params as getProductsListing
      const response = await downloadProductsExcelSheet(params);

      // Handle different response formats
      if (response?.status === 200 || response?.statusCode === 200) {
        // Get the actual data and headers
        const responseData = response.data || response;

        // Create blob - handle both binary and regular data
        let blob;
        if (responseData instanceof Blob) {
          blob = responseData;
        } else {
          const contentType = response.headers?.['content-type'] ||
            response.headers?.['Content-Type'] ||
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          blob = new Blob([responseData], { type: contentType });
        }

        // Create download URL
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        // Generate descriptive filename
        const dateStr = new Date().toISOString().split("T")[0];
        let fileName = `inventory_export_${filter}_${dateStr}`;

        // Add filter indicators to filename if active
        const filters = [];
        if (filterData.search) filters.push(`search-${filterData.search.substring(0, 10)}`);
        if (filterData.category?.length > 0) filters.push(`${filterData.category.length}-cats`);
        if (filterData.subCategory?.length > 0) filters.push(`${filterData.subCategory.length}-subcats`);
        if (filterData.brands?.length > 0) filters.push(`${filterData.brands.length}-brands`);
        if (filterData.vendors?.length > 0) filters.push(`${filterData.vendors.length}-vendors`);

        if (filters.length > 0) {
          fileName += `_${filters.join('_')}`;
        }

        fileName += '.xlsx';

        link.setAttribute("download", fileName);

        // Trigger download
        document.body.appendChild(link);
        link.click();
        link.remove();

        // Clean up URL object
        window.URL.revokeObjectURL(url);

        toast.success(`Inventory exported successfully! File: ${fileName}`);
      } else {
        toast.error(response?.data?.message || "Export failed");
      }
    } catch (error) {
      console.error("Error exporting inventory to Excel:", error);
      toast.error(error.message || "Failed to export inventory");
    } finally {
      setDownloadInventoryExcel(false);
    }
  };

  return (
    <>
      <div>
        {/* Sticky Header (lifted out of wrappers so it sticks throughout page scroll) */}
        <div className="page-header-sticky">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                  <div className="d-flex align-items-center">
                    <h3 className="mb-0 fw-bolder">Inventory</h3>
                  </div>

                  {/* Upper Row - Action Buttons */}
                  <div className="d-flex align-items-center gap-2 flex-wrap">

                  <div className="d-flex align-items-center">
                    <div
                      className='request_btn'
                      onClick={() => exportInventoryToExcel()}
                      style={{
                        cursor: 'pointer',
                        background: '#fff',
                        color: '#374151',
                        border: '1px solid #9ca3af',
                        borderRadius: '6px',
                        fontSize: '13px',
                      }}
                    >
                      {downloadInventoryExcel ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          <span>Exporting...</span>
                        </>
                      ) : (
                        <>
                          <FiDownload />
                          <span>Export Inventory</span>
                        </>
                      )}
                    </div>
                  </div>


                  <Button
                    variant="light"
                    className="request_btn btn-white-neutral"
                    onClick={handleShowBulkModal}
                    style={{
                      borderRadius: '6px',
                      fontSize: '13px',
                    }}
                  >
                    <FiUploadCloud className="icon" />
                    Bulk Inventory Upload
                  </Button>


                  {(user?.userType === "Vendor") && (
                    <Button
                      variant="light"
                      className="request_btn btn-white-neutral"
                      onClick={() => navigate("/sync-inventory")}
                      style={{
                        borderRadius: '6px',
                        fontSize: '13px',
                      }}
                    >
                      <FiRefreshCw className="icon" />
                      Smart Inventory
                    </Button>
                  )}

                  {checkUserPermissions("manage_products") ? (
                    <Button
                      className="request_btn ai-product-btn"
                      onClick={() => navigate("/create-ai-inventory")}
                      style={{
                        background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 50%, #ec4899 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(168, 85, 247, 0.35)',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      <FaWandMagicSparkles className="icon" style={{ filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.6))' }} />
                      AI Product Listing
                    </Button>
                  ) : null}

                  {checkUserPermissions("manage_products") ? (
                    <Button
                      className="request_btn"
                      onClick={() => navigate("/create-inventory")}
                      style={{ fontSize: '13px', borderRadius: '6px' }}
                    >
                      <FiPlus className="icon" size={18} strokeWidth={3} />
                      Add New Product
                    </Button>
                  ) : null}
                  </div>
                </div>

                {/* Search and Filter Bar (inside sticky header) */}
                <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                  <div style={{ flex: 2, minWidth: '260px' }}>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        className="form-control"
                        placeholder="Search for products..."
                        value={filterData.search}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        style={{
                          minHeight: "40px",
                          borderRadius: "8px",
                          fontSize: "13px",
                        }}
                      />
                    </Form.Group>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <Button
                      variant="outline-light"
                      onClick={() => setShowFilterModal(true)}
                      className="d-flex align-items-center gap-2"
                      style={{
                        border: '1px solid #9ca3af',
                        borderRadius: '6px',
                        padding: '8px 16px',
                        fontSize: '13px',
                        color: '#374151'
                      }}
                    >
                      <FiFilter />
                      Filter
                      {appliedFiltersCount > 0 && (
                        <span
                          className="badge bg-dark text-white"
                          style={{ fontSize: '12px' }}
                        >
                          {appliedFiltersCount}
                        </span>
                      )}
                    </Button>
                    <Button
                      variant="outline-light"
                      onClick={handleReset}
                      className="d-flex align-items-center"
                      style={{
                        border: '1px solid #9ca3af',
                        borderRadius: '6px',
                        padding: '8px 16px',
                        fontSize: '13px',
                        color: '#374151'
                      }}
                    >
                      Clear Filters
                    </Button>
                  </div>
                </div>
              </div>

              {/* <Offcanvas show={showOff} onHide={handleCloseOff} placement='end'>
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Filters</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="request_wrapper_filter">
                    <Form onSubmit={searchFormik.handleSubmit}>
                      <div className='seperation_filter_reports'>
                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Category</Form.Label>
                          <AsyncSelect
                            loadOptions={loadOptionsCategory}
                            defaultOptions={category}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder={'Search Categories'}
                            onChange={onCategoryChange}
                            value={searchFormik.values.selectedCategory}
                            noOptionsMessage={customNoOptionsMessage}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: " 1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Sub-Category</Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={loadOptionsSubCategory}
                            defaultOptions={true}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder={'Search Sub Categories'}
                            onChange={onSubCategoryChange}
                            value={searchFormik.values.selectedSubCategory}
                            isDisabled={searchFormik.values.selectedCategory === ''}
                            noOptionsMessage={customNoOptionsMessage}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: " 1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Brands</Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={loadOptionsBrands}
                            defaultOptions={brands}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder="Search Brands"
                            onChange={onBrandChange}
                            value={searchFormik.values.selected_brands}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            noOptionsMessage={() => (hasMore ? "Loading more options..." : "No more options")}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: "1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label className='mb-2'>Vendors</Form.Label>
                          <AsyncSelect
                            isMulti
                            loadOptions={loadOptionsManufacture}
                            defaultOptions={manufacturers}
                            classNamePrefix="select"
                            isClearable={true}
                            placeholder="Search Vendors"
                            onChange={onManufactureChange}
                            value={searchFormik.values.selected_vendors}
                            onMenuScrollToBottom={handleMenuScrollToBottomManufacture}
                            noOptionsMessage={() => (hasMoreManufacture ? "Loading more options..." : "No more options")}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: "0 10px 10px 10px",
                              colors: {
                                ...theme.colors,
                                primary: '#779be1',
                              },
                            })}
                            styles={{
                              menu: (baseStyles) => ({
                                ...baseStyles,
                                zIndex: 9999,
                              }),
                              control: (provided) => ({
                                ...provided,
                                border: "1px solid #a7a7a7",
                                padding: '6px',
                              }),
                            }}
                          />
                        </Form.Group>

                        <div className='btn-groups'>
                          <Button className='search_filter' type='submit'>Search</Button>
                          <Button className='reset_btn_wrapper' onClick={handleReset}>Reset</Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </Offcanvas.Body>
              </Offcanvas> */}



              {/* Filter Modal */}
              <FilterModal
                show={showFilterModal}
                onHide={() => setShowFilterModal(false)}
                filters={{}}
                onApplyFilters={() => {

                  searchFormik.handleSubmit();
                }}
                searchFormik={searchFormik}
                onCategoryChange={onCategoryChange}
                onSubCategoryChange={onSubCategoryChange}
                onBrandChange={onBrandChange}
                onManufactureChange={onManufactureChange}
                userType={user?.userType}
              />

          <CustomisedModal
            isOpen={modal}
            customClass={"policy_modal"}
            toggle={toggleModal}
          >
            <h5>Are you sure you want to remove this item?</h5>
            <div className="policy_Agree">
              <Button
                onClick={() => {
                  setModal(!modal);
                }}
                size="lg"
                className="btn_cancel"
              >
                Cancel
              </Button>
              <Button
                size="lg"
                className="btn"
                onClick={() => deleteProducts(deletingId)}
                disabled={loading}
              >
                {loading ? "Loading" : "Delete"}
              </Button>
            </div>
          </CustomisedModal>

          {filter == "all" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading || defaultLoading}
                    conditionalRowStyles={conditionalRowStyles}
                    pointerOnHover
                    highlightOnHover
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={limit}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    currentPage={page}
                    paginationDefaultPage={page}
                    customStyles={queueDatatableCustomStyles}
                    expandableRows
                    expandOnRowClicked={false}
                    onRowExpandToggled={handleRowExpand}
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowsHideExpander
                    onRowClicked={(row) => navigate("/edit-inventory/" + row.id)}
                    expandableRowExpanded={(row) => expandedRows.includes(row)}
                  />
                </div>
              </Paper>
            </Box>
          )}

          {filter == "active" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={activedata}
                    progressPending={loading || defaultLoading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    pointerOnHover
                    highlightOnHover
                    paginationTotalRows={totalActiveRows}
                    paginationPerPage={limitactive}
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    onChangeRowsPerPage={handlePerRowsActiveChange}
                    onChangePage={handlePageActiveChange}
                    currentPage={pageactive}
                    paginationDefaultPage={pageactive}
                    customStyles={queueDatatableCustomStyles}
                  />
                </div>
              </Paper>
            </Box>
          )}

          {filter == "inactive" && (
            <Box className="products-and-options" sx={{ mt: 1 }}>
              <Paper square className='shadow-none border border-blue-grey-200'>
                <div>
                  <DataTable
                    columns={columns}
                    data={inactivedata}
                    progressPending={loading || defaultLoading}
                    progressComponent={
                      <div style={{ height: "60vh" }}>
                        <Loader />
                      </div>
                    }
                    pagination
                    paginationServer
                    pointerOnHover
                    highlightOnHover
                    paginationTotalRows={totalInActiveRows}
                    paginationPerPage={limitinactive}
                    onChangeRowsPerPage={handlePerRowsInactiveChange}
                    onChangePage={handlePageInactiveChange}
                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                    currentPage={pageinactive}
                    paginationDefaultPage={pageinactive}
                    customStyles={queueDatatableCustomStyles}
                  />
                </div>
              </Paper>
            </Box>
          )}

          {/* Bulk Upload Modal */}
          <BulkUploadModal
            show={showBulkModal}
            onHide={handleCloseBulkModal}
            onSuccess={handleBulkUploadSuccess}
            sampleFile={sampleFile}
            sampleImageFile={sampleImageFile}
          />
      </div>
    </>
  );
};

export default Inventory;
